export interface LocalePayload {
  locale: "tr" | "en";
  data: Record<string, string>;
}

/**
 * Aktif locale'e tam form değerlerini yazar. Görsel (dil-bağımsız) anahtarları diğer
 * locale'in mevcut verisi üzerine mirror'lar. Görsel yoksa yalnız aktif payload döner.
 */
export function buildMirrorPayloads(args: {
  activeLocale: "tr" | "en";
  values: Record<string, string>;
  imageKeys: string[];
  otherLocaleData: Record<string, string>;
}): LocalePayload[] {
  const { activeLocale, values, imageKeys, otherLocaleData } = args;
  const payloads: LocalePayload[] = [{ locale: activeLocale, data: values }];
  if (imageKeys.length === 0) return payloads;

  const other = activeLocale === "tr" ? "en" : "tr";
  const mirrored: Record<string, string> = { ...otherLocaleData };
  for (const k of imageKeys) mirrored[k] = values[k] ?? "";
  payloads.push({ locale: other, data: mirrored });
  return payloads;
}
